import wx from 'weixin-js-sdk';
import userService from "./UserService"
import {Toast} from "mint-ui"
import image from "../status/images/5ibzy-blue.png"
const wxApi = {
    /**
    * [isweixin 判断是否微信浏览器]
    */
    isweixin() {
        const ua = window
            .navigator
            .userAgent
            .toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true
        } else {

            return false
        }
    },
    isIos(){
        let isIphone = navigator.userAgent.includes('iPhone');
        let isIpad = navigator.userAgent.includes('iPad');
        return isIphone || isIpad;
    },
    wxConfig() {
        let url = window.location.href.split("#")[0]
        userService.getticket({url}).then(res => {
                wx.config({
                    debug: false, // 开启调试模式
                    appId: res.appId, // 必填，公众号的唯一标识
                    timestamp: res.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.nonceStr, // 必填，生成签名的随机串
                    signature: res.signature, // 必填，签名，见附录1
                    jsApiList: [
                        'onMenuShareAppMessage', // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
                        'onMenuShareTimeline', // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
                        'onMenuShareQQ', //获取“分享到QQ”按钮点击状态
                        'onMenuShareQZone'
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                })
            })
            .catch((error) => {
                console.log(error)
            })
    },
    /**
    * [wxRegister 微信Api初始化]
    * @param  {Function} callback [ready回调函数]
    */
    wxRegister(options) {
        if(!this.isIos()){
            this.wxConfig();
        }else{
            this.shareAll(options);
            return;
        }
        if (/^image/.test(options.imgUrl)) {
            options.imgUrl = window.location.origin + "/" + options.imgUrl;
        }
        wx.ready((res) => {
            // 如果需要定制ready回调方法
            this.ShareTimeline(options);
            this.ShareFriend(options);
            this.ShareQQ(options);
            this.ShareQZone(options)
        })

    },
    shareAll(options) {
        if (/^image/.test(options.imgUrl)) {
            options.imgUrl = window.location.origin + "/" + options.imgUrl;
        }
        this.ShareTimeline(options);
        this.ShareFriend(options);
        this.ShareQQ(options);
        this.ShareQZone(options)
    },
    initWeiXin() {
        this.wxConfig();
        let src = "/#/register";
        let options = {
            title: "5i八爪鱼", // 分享标题
            link: window.location.origin + src, // 分享链接
            imgUrl: image, // 分享图标
            desc: "欢迎来到5i八爪鱼-专业的金融软件和服务提供平台", // 分享描述
        }
        if (/^image/.test(options.imgUrl)) {
            options.imgUrl = window.location.origin + "/" + options.imgUrl;
        }
        wx.ready((res) => {
            // 如果需要定制ready回调方法 
            this.ShareTimeline(options);
            this.ShareFriend(options);
            // this.ShareQQ(options); this.ShareQZone(options)
        })
    },
    /**
    * [ShareTimeline 微信分享到朋友圈]
    * @param {[type]} opstion [分享信息]
    * @param {[type]} success [成功回调]
    * @param {[type]} error   [失败回调]
    */
    ShareTimeline(opstion) {
        wx.onMenuShareTimeline({
            title: opstion.title, // 分享标题
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            success() {
                // 用户成功分享后执行的回调函数
                if (opstion.success == "" || opstion.success == null || typeof opstion.success == "undefined") {
                    opstion.success = res => {
                        Toast("分享成功！");
                    }
                }
                opstion.success()
            },
            cancel() {
                // 用户取消分享后执行的回调函数
                if (opstion.error == "" || opstion.error == null || typeof opstion.error == "undefined") {
                    opstion.error = res => {
                        Toast("分享失败！");
                    }
                }
                opstion.error()
            }
        })
    },
    //分享给朋友
    ShareFriend(opstion) {
        wx.onMenuShareAppMessage({
            title: opstion.title, // 分享标题
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            desc: opstion.desc, // 分享描述
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success() {
                // 用户成功分享后执行的回调函数
                if (opstion.success == "" || opstion.success == null || typeof opstion.success == "undefined") {
                    opstion.success = res => {
                        Toast("分享成功！");
                    }
                }
                opstion.success()
            },
            cancel() {
                // 用户取消分享后执行的回调函数
                if (opstion.error == "" || opstion.error == null || typeof opstion.error == "undefined") {
                    opstion.error = res => {
                        Toast("分享失败！");
                    }
                }
                opstion.error()
            }
        })
    },
    ShareQQ(opstion) {
        wx.onMenuShareQQ({
            title: opstion.title, // 分享标题
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            desc: opstion.desc, // 分享描述
            success() {
                // 用户成功分享后执行的回调函数
                if (opstion.success == "" || opstion.success == null || typeof opstion.success == "undefined") {
                    opstion.success = res => {
                        Toast("分享成功！");
                    }
                }
                opstion.success()
            },
            cancel() {
                // 用户取消分享后执行的回调函数
                if (opstion.error == "" || opstion.error == null || typeof opstion.error == "undefined") {
                    opstion.error = res => {
                        Toast("分享失败！");
                    }
                }
                opstion.error()
            }
        });
    },
    ShareQZone(opstion) {
        wx.onMenuShareQZone({
            title: opstion.title, // 分享标题
            link: opstion.link, // 分享链接
            imgUrl: opstion.imgUrl, // 分享图标
            desc: opstion.desc, // 分享描述
            success() {
                // 用户成功分享后执行的回调函数
                if (opstion.success == "" || opstion.success == null || typeof opstion.success == "undefined") {
                    opstion.success = res => {
                        Toast("分享成功！");
                    }
                }
                opstion.success()
            },
            cancel() {
                // 用户取消分享后执行的回调函数
                if (opstion.error == "" || opstion.error == null || typeof opstion.error == "undefined") {
                    opstion.error = res => {
                        Toast("分享失败！");
                    }
                }
                opstion.error()
            }
        });
    }
}
export default wxApi;


// WEBPACK FOOTER //
// ./src/service/weixinService.js